import { Table, TableHead, TableBody, TableRow, TableCell, Typography } from "@mui/material";

export default function MarksTable({ fullCandidateDetails }) {
  const details = fullCandidateDetails?.[0] || {};
console.log(details,'pks')
  const rows = [
    { year: "First Year", obtained: details?.fymarksobtained, outof: details?.fymarksoutof, percentage: details?.fypercentage, attempts: details?.fynoofattempts },
    { year: "Second Year", obtained: details?.symarksobtained, outof: details?.symarksoutof, percentage: details?.sypercentage, attempts: details?.synoofattempts },
    { year: "Third Year", obtained: details?.tymarksobtained, outof: details?.tymarksoutof, percentage: details?.typercentage, attempts: details?.tynoofattempts },
    { year: "Fourth Year (if applicable)", obtained: details?.fourymarksobtained, outof: details?.fourymarksoutof, percentage: details?.fourypercentage, attempts: details?.fourynoofattempts },
    { year: "Aggregate Marks", obtained: details?.aggregatemarksobtained, outof: details?.aggregatemarksoutof, percentage: details?.aggregatepercentage, attempts: "" },
  ];

  return (
    <Table
  sx={{
    border: "1px solid #000",
    borderCollapse: "collapse",
    width: "100%",
    fontSize: "10px",
  }}
>
  <TableHead>
    <TableRow>
      <TableCell sx={{ border: "1px solid #000", fontWeight: "bold",padding:"0px!important",fontSize:"12px" }}></TableCell>
      <TableCell sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center" ,padding:"0px!important",fontSize:"12px" }}>
        Marks Obtained
      </TableCell>
      <TableCell sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center",padding:"0px!important",fontSize:"12px" }}>
        Marks Out Of
      </TableCell>
      <TableCell sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center",padding:"0px!important",fontSize:"12px" }}>
        Percentage Of Marks
      </TableCell>
      <TableCell sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center",padding:"0px!important",fontSize:"12px" }}>
        No Of Attempts
      </TableCell>
    </TableRow>
  </TableHead>

  <TableBody>
    {rows.map((row, i) => (
      <TableRow key={i}>
        <TableCell sx={{ border: "1px solid #000",fontSize:"10px" ,padding:"0px 4px!important"}}>{row?.year}</TableCell>

        <TableCell sx={{ border: "1px solid #000", textAlign: "center",fontSize:"10px",fontWeight:"bold" ,padding:"0px!important"}}>
         {row?.obtained ? parseFloat(row?.obtained).toFixed(2) : 0.00}
        </TableCell>

        <TableCell sx={{ border: "1px solid #000", textAlign: "center",fontSize:"10px",fontWeight:"bold" ,padding:"0px!important"}}>
          {row?.outof ? parseFloat(row?.outof).toFixed(2) : 0.00}
        
        </TableCell>

        <TableCell sx={{ border: "1px solid #000", textAlign: "center",fontSize:"10px",fontWeight:"bold" ,padding:"0px!important"}}>
         
           {row?.percentage ? parseFloat(row?.percentage).toFixed(2) : 0.00}{" "} %
        </TableCell>

        <TableCell sx={{ border: "1px solid #000", textAlign: "center",fontSize:"10px",fontWeight:"bold",padding:"0px!important"}}>
          {row?.attempts===0 ? "Not Applicable":  row?.attempts ? row?.attempts : "" }
        </TableCell>
      </TableRow>
    ))}
  </TableBody>
</Table>

  );
}
